import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import Table from '@aytm/app/stats/components/data-views/table/components/Table'
import {
  calcTvItemsListProps,
  sortOrderOf
} from '@aytm/app/stats/page/question-views/bpm/components/tv/lib/table-utils'

const TvTable = ({
  id,
  answer,
  questionVariants,
  batches,
  defaultValues,
  showResponses,
  sortOrder,
  tvPlotByValue,
  tvElevationsRepresentValue,
  tvBrandsValue,
  tvAttributesValue,
  onModelChange
}) => {
  const { cols, rows } = calcTvItemsListProps({
    id,
    answer,
    questionVariants,
    batches,
    tvPlotByValue,
    tvElevationsRepresentValue,
    tvBrandsValue,
    tvAttributesValue,
    defaultValues: defaultValues.t,
    showResponses,
    sortOrder
  })

  // Only the thermometer list keeps its sort: it rides in bpm<key>, so the click is announced
  // rather than sorted in place. A column with no letter of its own is not sortable.
  const onSort = (colIndex, dir, sortedCols) => {
    const token = sortedCols[colIndex]?.sortToken
    if (token) onModelChange({ sortOrder: sortOrderOf(token, dir) })
  }

  return <Table cols={cols} rows={rows} onSort={onSort} />
}

TvTable.displayName = 'BpmTvTable'

TvTable.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  answer: answerPropType,
  questionVariants: PropTypes.array,
  batches: PropTypes.array,
  defaultValues: PropTypes.object,
  showResponses: PropTypes.bool,
  sortOrder: PropTypes.string,
  tvPlotByValue: PropTypes.string,
  tvElevationsRepresentValue: PropTypes.string,
  tvBrandsValue: PropTypes.array,
  tvAttributesValue: PropTypes.array,
  onModelChange: PropTypes.func
}

export default TvTable
